import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import {
  format,
  setYear,
  setMonth,
  setDate,
  addMonths,
  getMonth,
  subDays,
} from 'date-fns';

import { connect } from 'react-redux';
import styles from './confirmRequestModal.module.scss';
import { Button, WithSpinner, InputWithTextInline } from '../../components';
import { actions } from '../../state/actions';
import swal from 'sweetalert';
import { Api } from './../../api/api';
import { config } from './../../api/config';
import {
  isSumValid2,
  isInterestRateValid,
  isInterestVariableRateValid,
  validateTextinput,
} from './../../utils/auth/validations';
// import { errorhandle } from '../../utils/helpers/helpers';

const ConfirmRequestModal = ({
  open,
  requestId,
  loading,
  dispatch,
  comment,
  loanDelayTerm,
  invegaLoanSum2,
  invegaLoanInterestRate2,
  invegaLoanVariableInterestRate2,
  InvegaLoanPaymentTerm2,
  invegaContractNumber2,
  loanPurposeId,
  invegaSigningDate,
  invegaLoanDelayTerm2,
  invegaPaymentDate2,
}) => {
  const [isLoading, setIsloading] = useState(false);
  const [notValid, setNotValid] = useState(false);
  const [invegaLoanInterestRate, setInvegaLoanInterestRate] = useState(
    invegaLoanInterestRate2
  );
  const [invegaLoanVariableInterestRate, setInvegaLoanVariableInterestRate] =
    useState(invegaLoanVariableInterestRate2);
  const [invegaLoanPaymentTerm, setinvegaLoanPaymentTerm] = useState(
    InvegaLoanPaymentTerm2
  );

  const [generateInvoice, setGenerateInvoice] = useState(false);
  const [invoiceFee, setInvoiceFee] = useState(null);

  const [invegaLoanSum, setInvegaLoanSum] = useState(invegaLoanSum2);
  const [invegaContractNumber, setInvegaContractNumber] = useState(
    invegaContractNumber2
  );
  // const [invegaLoanDelayTermDate, setInvegaLoanDelayTermDate] = useState(
  //   invegaLoanDelayTermDate2
  //);
  const [invegaPaymentDate, setInvegaPaymentDate] =
    useState(invegaPaymentDate2);
  const [fileToUpload, setFileToUpload] = useState(null);
  const [invegaLoanDelayTerm, setInvegaLoanDelayTerm] = useState(
    loanDelayTerm ? loanDelayTerm : null
  );
  //const [firstInterestChangeDate, setfirstInterestChangeDate] = useState(null);
  const [euriborChangeDate, seteuriborChangeDate] = useState(null);
  const [interestTypeId, setInterestTypeId] = useState(1);
  const [euriborPeriodId, setEuriborPeriodId] = useState(3);

  const [invegaLoanPurposeId, setInvegaLoanPurposeId] = useState(loanPurposeId);
  //console.log(invegaLoanPurposeId);
  const validateTextinput = (val, name, length, msg = 'Neįvestas') => {
    if (val == null || val.length === 0) {
      return `${msg} ${name} `;
    } else if (length == null ? val.length < length : val.length < length) {
      return `* per trumpas ${name} `;
    } else {
      return null;
    }
  };

  const cancel = () => {
    setNotValid(false);
    setInvegaLoanInterestRate(invegaLoanInterestRate2);
    setInvegaLoanVariableInterestRate(invegaLoanVariableInterestRate2);
    setinvegaLoanPaymentTerm(InvegaLoanPaymentTerm2);
    setInvegaLoanSum(invegaLoanSum2);
    setinvegaLoanPaymentTerm(null);
    //setfirstInterestChangeDate(null);
    seteuriborChangeDate(null);
    setInvegaContractNumber(invegaContractNumber2);
    //setInterestTypeId(null);
    //setEuriborPeriodId(null);
    setGenerateInvoice(false);
    setFileToUpload(null);
    setInvoiceFee(null);
    //setInvegaLoanDelayTermDate(null);
    setInvegaPaymentDate(null);
    setInvegaLoanDelayTerm(invegaLoanDelayTerm2);
    setInvegaLoanPurposeId(loanPurposeId);

    const open = {
      modalName: 'confirmRequestModal',
      visible: false,
    };
    dispatch(actions.modals.setModalVisibleFlagAction(open));
  };

  const validatateIfSF = () => {
    if (!generateInvoice) {
      return true;
    }
    if (generateInvoice && isSumValid2(invoiceFee) === null) {
      return true;
    }
    return false;
  };

  const validateFieldsBasedOnInterestType = (selectedField) => {
    if (interestTypeId != '2') {
      return true;
    }
    return selectedField;
  };

  const yes = async () => {
    if (
      invegaLoanInterestRate &&
      //validateFieldsBasedOnInterestType(invegaLoanVariableInterestRate) &&
      invegaLoanPaymentTerm &&
      //validateFieldsBasedOnInterestType(euriborChangeDate) &&
      //validateFieldsBasedOnInterestType(euriborPeriodId) &&
      isSumValid2(invegaLoanSum) === null &&
      isInterestRateValid(invegaLoanInterestRate) === null &&
      //isInterestVariableRateValid(invegaLoanVariableInterestRate) === null &&
      invegaContractNumber &&
      // invegaLoanDelayTerm &&
      //interestTypeId &&
      //euriborPeriodId &&
      invegaLoanDelayTerm &&
      invegaPaymentDate &&
      validatateIfSF() &&
      fileToUpload
      //invegaLoanPurposeId
    ) {
      const formData = new FormData();
      const formattedData = invegaLoanPaymentTerm
        ? format(new Date(invegaLoanPaymentTerm), 'yyyy-MM-dd')
        : '';
      //const formattedData2 = firstInterestChangeDate
      // ? format(new Date(firstInterestChangeDate || ''), 'yyyy-MM-dd')
      //  : '';
      const formattedData3 = euriborChangeDate
        ? format(new Date(euriborChangeDate), 'yyyy-MM-dd')
        : '';
      formData.append('RequestId', requestId);
      formData.append('InvegaLoanInterestRate', invegaLoanInterestRate);
      formData.append('InterestTypeId', interestTypeId ? interestTypeId : 1);
      if (interestTypeId == 1) {
        formData.append('EuriborChangeDate', formattedData3);
        formData.append(
          'EuriborPeriodId',
          euriborPeriodId ? euriborPeriodId : 1
        );
        formData.append(
          'InvegaLoanVariableInterestRate',
          invegaLoanVariableInterestRate
        );
      }
      formData.append('InvegaLoanPaymentTerm', formattedData);
      // formData.append('FirstInterestChangeDate', formattedData2);

      formData.append('InvegaLoanDelayTerm', invegaLoanDelayTerm);

      formData.append('InvegaLoanSum', invegaLoanSum);
      formData.append('InvegaContractNumber', invegaContractNumber);

      formData.append('GenerateInvoice', generateInvoice);
      formData.append('InvegaLoanPurposeId', invegaLoanPurposeId);
      //formData.append(
      //  'InvegaLoanDelayTermDate',
      //  invegaLoanDelayTermDate
      //    ? format(new Date(invegaLoanDelayTermDate), 'yyyy-MM-dd')
      //    : ''
      //);
      formData.append(
        'InvegaPaymentDate',
        invegaPaymentDate
          ? format(new Date(invegaPaymentDate), 'yyyy-MM-dd')
          : ''
      );
      formData.append('File', fileToUpload);
      if (generateInvoice) {
        formData.append('InvoiceFee', invoiceFee);
      }
      setIsloading(true);
      //const doubleCheck = await Api.doubleCheckRequestEvaluation(requestId);
      //if (doubleCheck && doubleCheck?.Decision === 1) {

      fetch(Api.API_BASE_URL + config.API_ENDPOINTS.UploadContract(comment), {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem('token')}`,
        },
        body: formData,
      })
        .then((res) => {
          if (res.ok === true) {
            swal({
              title: 'Paraiška sėkmingai pateikta pareiškėjo pasirašymui',
              icon: 'success',
              buttons: {
                confirm: {
                  text: 'Gerai',
                  value: true,
                  visible: true,
                  className: 'btn btn-pink',
                  closeModal: true,
                },
              },
            }).then((results) => {
              if (results) {
                window.location.reload();
              }
            });
          } else if (res.status === 403) {
            swal({
              title: `Šiam veiksmui atlikti neturite reikiamų teisių. Kreipkitės į sistemos administratorių`,
              icon: 'error',
              buttons: {
                confirm: {
                  text: 'Gerai',
                  value: true,
                  visible: true,
                  className: 'btn swal-ok-btn',
                  closeModal: true,
                },
              },
            });
          } else {
            res.json().then((r) => {
              swal({
                title: `${
                  r.ErrorDescription ? r.ErrorDescription : 'Įvyko klaida'
                }`,
                icon: 'error',
                buttons: {
                  confirm: {
                    text: 'Gerai',
                    value: true,
                    visible: true,
                    className: 'btn swal-ok-btn',
                    closeModal: true,
                  },
                },
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsloading(false);
        });
      {
        /*}} else {
        swal({
          title: `Paraiška negali būti finansuojama nes neatitinka visų finansavimo taisyklių`,
          icon: 'error',
          buttons: {
            confirm: {
              text: 'Gerai',
              value: true,
              visible: true,
              className: 'btn swal-ok-btn',
              closeModal: true,
            },
          },
        });
        setIsloading(false);
        cancel();
      }*/
      }
    } else {
      setNotValid(true);
    }
  };
  const selectFile = (id) => {
    document.getElementById(id).click();
  };

  const onInterestTypeIdChange = (val) => {
    setInterestTypeId(val.target.value);
  };

  const onEuriborPeriodIdChange = (val) => {
    setEuriborPeriodId(val.target.value);
  };

  const checkLoanDelayTermFormat = (val) => {
    if (!Number.isInteger(+val)) {
      return 'Turi būti įvestas sveikas skaičius';
    }
    // if (
    //   +val > 0 &&
    //   +val <= 120 &&
    //   invegaLoanPaymentTerm &&
    //   +val > +invegaLoanPaymentTerm
    // ) {
    //   return ' lauko [paskolos atidėjimo terminas (mėn)] reikšmė negali būti didesnė negu lauko [Pageidaujamas Paskolos terminas mėn].';
    // }
    if (+val >= 1 && +val <= 120) {
      return null;
    }

    return 'Turi būti įvestas sveikas skaičius nuo 1 iki 120';
  };

  const returnFirstInterestChangeDate = () => {
    const invedaSign = new Date(invegaSigningDate);

    if (isNaN(invedaSign)) {
      return '';
    }
    if (euriborPeriodId == '4') {
      let nextYearFirstDay = setYear(invedaSign, invedaSign.getFullYear() + 1);
      nextYearFirstDay = setMonth(nextYearFirstDay, 0);
      nextYearFirstDay = setDate(nextYearFirstDay, 1);

      return nextYearFirstDay;
    } else if (euriborPeriodId == '3') {
      const month = getMonth(invedaSign);
      let halfYearLater = new Date(invedaSign);

      if (month > 5) {
        halfYearLater = addMonths(invedaSign, 6);
        halfYearLater = setMonth(halfYearLater, 0);
        halfYearLater = setDate(halfYearLater, 1);
      } else {
        halfYearLater = setMonth(halfYearLater, 5);
        halfYearLater = setDate(halfYearLater, 1);
      }

      return halfYearLater;
    } else if (euriborPeriodId == '2') {
      const month = getMonth(invedaSign);
      let quarterYearLater = new Date(invedaSign);

      if (month < 3) {
        quarterYearLater = setMonth(quarterYearLater, 3);
        quarterYearLater = setDate(quarterYearLater, 1);
      } else if (month > 2 && month < 6) {
        quarterYearLater = setMonth(quarterYearLater, 7);
        quarterYearLater = setDate(quarterYearLater, 1);
      } else if (month > 5 && month < 9) {
        quarterYearLater = setMonth(quarterYearLater, 9);
        quarterYearLater = setDate(quarterYearLater, 1);
      } else if (month > 8) {
        quarterYearLater = setYear(invedaSign, invedaSign.getFullYear() + 1);
        quarterYearLater = setMonth(quarterYearLater, 0);
        quarterYearLater = setDate(quarterYearLater, 1);
      }

      return quarterYearLater;
    }

    return '';
  };

  //useEffect(() => {
  //   setfirstInterestChangeDate(returnFirstInterestChangeDate());
  // }, [euriborPeriodId]);

  return (
    open && (
      <div className={styles.container}>
        <div
          className={styles.modal}
          id="modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal__title"
          aria-describedby="modal__desc"
        >
          <WithSpinner loading={isLoading}>
            <h2>Pateikti pareiškėjo pasirašymui</h2>
            <div className={styles.inputsContainer}>
              <div
                className={styles.inputsInline}
                style={{ marginLeft: '1rem', width: '140px' }}
              >
                <div>
                  <InputWithTextInline
                    type="string"
                    value={invegaContractNumber}
                    onChange={(e) => setInvegaContractNumber(e.target.value)}
                    placeholder={'Sutarties numeris'}
                    disabled={false}
                  />
                  {notValid && !invegaContractNumber && (
                    <p
                      className={styles.error}
                      style={{ textAlign: 'left', width: '100%' }}
                    >
                      Neįvestas sutarties numeris
                    </p>
                  )}
                </div>
              </div>

              <div
                className={styles.inputsInline}
                style={{
                  marginRight: '1.5rem',
                  width: '140px',
                  marginLeft: '1.5rem',
                }}
              >
                <div>
                  <InputWithTextInline
                    type="string"
                    value={invegaLoanSum}
                    onChange={(e) => setInvegaLoanSum(e.target.value)}
                    placeholder={'Paskolos suma'}
                    disabled={false}
                  />
                  {notValid && (
                    <p
                      className={styles.error}
                      style={{ textAlign: 'left', width: '100%' }}
                    >
                      {isSumValid2(invegaLoanSum, 'privalomas laukas', 3)}
                      {/* Privalote įrašyti paskolos sumą */}
                    </p>
                  )}
                </div>
              </div>

              <div
                className={styles.inputsInline}
                style={{ marginRight: '1.5rem', marginTop: '19px' }}
              >
                <label
                  style={{
                    margin: '15px 0 8px',
                    color: '#597a96',
                    fontSize: '0.8rem',
                    lineHeight: '1',
                  }}
                >
                  Paskolos paskirtis
                </label>
                <select
                  name="LoanPurposeId"
                  onChange={(e) => setInvegaLoanPurposeId(e.target.value)}
                  value={invegaLoanPurposeId}
                  style={{ marginLeft: '0px', marginTop: '5px' }}
                >
                  {/* <option value={null}>{null}</option> */}
                  <option value={'1'}>Investicinė</option>
                  <option value={'2'}>Apyvartinė</option>
                </select>
                {/* {notValid &&
                (loanInfo.LoanPurposeId == null ||
                  loanInfo.LoanPurposeId == null) && (
                  <p className="errorsBlockText error1">
                    Privalote pasirinkti paskolos paskirtį
                  </p>
                )} */}
              </div>

              <div
                className={styles.inputsInline}
                style={{ marginRight: '2.5rem', width: '150px' }}
              >
                <div>
                  <label
                    className="inlineDatepickerInputTitle"
                    style={{ width: '150px', marginTop: '1.5rem' }}
                  >
                    Galutinis paskolos grąžinimo terminas
                  </label>
                  <DatePicker
                    className="inlineDatepickerInput"
                    value={
                      invegaLoanPaymentTerm
                        ? new Date(invegaLoanPaymentTerm)
                        : ''
                    }
                    selected={
                      invegaLoanPaymentTerm
                        ? new Date(invegaLoanPaymentTerm)
                        : ''
                    }
                    // onChange={(e) => console.log(e)}

                    onChange={(e) => setinvegaLoanPaymentTerm(e)}
                    minDate={new Date()}
                    dateFormat="yyyy-MM-dd"
                    disabled={false}
                    style={{ width: '50px' }}
                  />

                  {notValid && !invegaLoanPaymentTerm && (
                    <p
                      className={styles.error}
                      style={{ textAlign: 'left', width: '100%' }}
                    >
                      Neįvestas paskolos terminas
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className={styles.inputsContainer}>
              <div
                className={styles.inputsInline}
                style={{ width: '180px', marginTop: '1.3rem' }}
              >
                <label
                  //style={{ marginTop: '13px' }}
                  className="inlineDatepickerInputTitle"
                >
                  Paskolos atidėjimo terminas (mėn.)
                </label>
                {/*<label
                  style={{ marginTop: '36px' }}
                  className="inlineDatepickerInputTitle"
                >
                  Atidėjimo terminas (mėn)
                  </label>*/}

                {/*<DatePicker
                  className="inlineDatepickerInput"
                  style={{ marginLeft: '0px', padding: '0px' }}
                  value={
                    invegaLoanDelayTermDate
                      ? new Date(invegaLoanDelayTermDate)
                      : ''
                  }
                  selected={
                    invegaLoanDelayTermDate
                      ? new Date(invegaLoanDelayTermDate)
                      : ''
                  }
                  // onChange={(e) => console.log(e)}

                  onChange={(e) => setInvegaLoanDelayTermDate(e)}
                  minDate={new Date()}
                  dateFormat="yyyy-MM-dd"
                  disabled={false}
                />
                {notValid && !invegaLoanDelayTermDate && (
                  <p className={styles.error} style={{ marginLeft: '1rem' }}>
                    Neįvesta data
                  </p>
                )}*/}
                <InputWithTextInline
                  type="string"
                  value={invegaLoanDelayTerm}
                  onChange={(e) => setInvegaLoanDelayTerm(e.target.value)}
                  // placeholder={'Paskolos atidėjimo terminas (mėn.)'}
                  disabled={false}
                  style={{ marginTop: '-2.1rem' }}
                />
                {notValid &&
                  (validateTextinput(
                    invegaLoanDelayTerm,
                    'privalomas laukas',
                    1
                  ) ||
                    checkLoanDelayTermFormat(invegaLoanDelayTerm)) && (
                    //!disableCheck('LoanDelayTerm') &&
                    <p className={styles.error} style={{ width: '140px' }}>
                      {validateTextinput(
                        invegaLoanDelayTerm,
                        'privalomas laukas',
                        1
                      )}
                      {!validateTextinput(
                        invegaLoanDelayTerm,
                        'privalomas laukas',
                        1
                      ) && checkLoanDelayTermFormat(invegaLoanDelayTerm)}
                    </p>
                  )}
              </div>
              <div
                className={styles.inputsInline}
                style={{
                  marginLeft: '1rem',
                  width: '180px',
                  marginTop: '2.2rem',
                }}
              >
                <label
                  style={{ marginTop: '3px' }}
                  className="inlineDatepickerInputTitle"
                >
                  Išmokėjimo terminas{' '}
                </label>
                <DatePicker
                  className="inlineDatepickerInput"
                  style={{ marginLeft: '0px', padding: '0px' }}
                  value={invegaPaymentDate ? new Date(invegaPaymentDate) : ''}
                  selected={
                    invegaPaymentDate ? new Date(invegaPaymentDate) : ''
                  }
                  // onChange={(e) => console.log(e)}

                  onChange={(e) => setInvegaPaymentDate(e)}
                  minDate={new Date()}
                  dateFormat="yyyy-MM-dd"
                  disabled={false}
                />
                {notValid && !invegaPaymentDate && (
                  <p className={styles.error} style={{ marginLeft: '1rem' }}>
                    Neįvesta data
                  </p>
                )}
              </div>

              <div
                className={styles.inputsInline}
                style={{ width: '150px', marginLeft: '2rem' }}
              >
                <label
                  style={{ marginTop: '2.4rem' }}
                  className="inlineDatepickerInputTitle"
                >
                  Marža, %{' '}
                </label>

                <InputWithTextInline
                  type="string"
                  value={invegaLoanInterestRate}
                  onChange={(e) => setInvegaLoanInterestRate(e.target.value)}
                  //placeholder={'Marža, %'}
                  disabled={false}
                  style={{
                    marginLeft: '0px',
                    paddingleft: '5px',
                    marginTop: '-2rem',
                    width: '130px',
                  }}
                />
                {notValid && (
                  <p
                    className={styles.error}
                    style={{ textAlign: 'left', width: '100%' }}
                  >
                    {isInterestRateValid(
                      invegaLoanInterestRate,
                      'privalomas laukas',
                      3
                    )}
                  </p>
                )}
              </div>

              {interestTypeId != '2' && (
                <div className={styles.inputsInline} style={{ width: '200px' }}>
                  <div>
                    <InputWithTextInline
                      type="string"
                      value={invegaLoanVariableInterestRate}
                      onChange={(e) =>
                        setInvegaLoanVariableInterestRate(e.target.value)
                      }
                      placeholder={'Kintama palūkanų dalis, %'}
                      disabled={false}
                      style={{ width: '150px', marginLeft: '10px' }}
                    />
                    {notValid && interestTypeId != '2' && (
                      <p
                        className={styles.error}
                        style={{ textAlign: 'left', width: '100%' }}
                      >
                        {isInterestVariableRateValid(
                          invegaLoanVariableInterestRate,
                          'privalomas laukas',
                          3
                        )}
                        {/* Privalote įrašyti paskolos sumą */}
                      </p>
                    )}
                  </div>
                </div>
              )}
            </div>

            <div className={styles.inputsContainer}>
              <div
                className={styles.bottomInput}
                style={{ marginTop: '-1rem' }}
              >
                <label
                  style={{ marginTop: '33px', width: '110%' }}
                  className="inlineDatepickerInputTitle"
                >
                  Palūkanų normos rūšis
                </label>

                <select
                  disabled={false}
                  name="interestTypeId"
                  onChange={onInterestTypeIdChange}
                  value={interestTypeId}
                >
                  <option value={'1'}>Kintama</option>
                  <option value={'2'}>Fiksuota</option>
                </select>
              </div>
              {interestTypeId != '2' && (
                <div
                  className={styles.bottomInput}
                  style={{ marginTop: '-1rem' }}
                >
                  <label
                    style={{ marginTop: '33px', width: '110%' }}
                    className="inlineDatepickerInputTitle"
                  >
                    Taikomo Euribor pasikeitimo data
                  </label>
                  <DatePicker
                    className="inlineDatepickerInput"
                    style={{ marginLeft: '0px', padding: '20px' }}
                    value={euriborChangeDate ? new Date(euriborChangeDate) : ''}
                    selected={
                      euriborChangeDate ? new Date(euriborChangeDate) : ''
                    }
                    // onChange={(e) => console.log(e)}

                    onChange={(e) => seteuriborChangeDate(e)}
                    minDate={subDays(new Date(), 10)}
                    dateFormat="yyyy-MM-dd"
                    disabled={false}
                  />
                  {notValid && !euriborChangeDate && interestTypeId != '2' && (
                    <p className={styles.error} style={{ marginLeft: '60px' }}>
                      Neįvesta data
                    </p>
                  )}
                </div>
              )}
              {interestTypeId != '2' && (
                <div
                  className={styles.bottomInput}
                  style={{ marginTop: '-1rem' }}
                >
                  <label
                    style={{ marginTop: '33px', width: '110%' }}
                    className="inlineDatepickerInputTitle"
                  >
                    Palūkanų normos perskaičiavimo dažnumas
                  </label>
                  <select
                    disabled={false}
                    name="euriborPeriodId"
                    onChange={onEuriborPeriodIdChange}
                    value={euriborPeriodId}
                    defaultValue={'3'}
                  >
                    <option value={'1'}>1 mėn.</option>
                    <option value={'2'}>3 mėn.</option>
                    <option value={'3'}>6 mėn.</option>
                    <option value={'4'}>12 mėn.</option>
                  </select>
                </div>
              )}
            </div>
            <div style={{ height: generateInvoice ? '100px' : '40px' }}>
              <div className={styles.invoiceContainer}>
                <div
                  className={styles.invoiceInline}
                  style={{ width: '200px' }}
                >
                  <label
                    className="containerLabel noBlock"
                    style={{ marginTop: '3rem' }}
                  >
                    <input
                      type="checkbox"
                      name={'generateInvoice'}
                      checked={generateInvoice}
                      onChange={() => setGenerateInvoice(!generateInvoice)}
                    />
                    <span className="checkmark"></span>
                    <span className={styles.checkboxTitle}>
                      Generuoti sąskaitą faktūrą
                    </span>
                  </label>
                </div>
              </div>
              {generateInvoice && (
                <div
                  className={styles.invoiceInline}
                  style={{ marginRight: '0rem', marginTop: '1rem' }}
                >
                  <div>
                    <InputWithTextInline
                      type="number"
                      value={invoiceFee}
                      onChange={(e) => setInvoiceFee(e.target.value)}
                      placeholder={'Sutarties sudarymo mokestis'}
                      disabled={false}
                    />
                    {notValid && (
                      <p
                        className={styles.error}
                        style={{ textAlign: 'left', width: '100%' }}
                      >
                        {isSumValid2(invoiceFee, 'privalomas laukas', 3)}
                      </p>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className={styles.addFileContainer}>
              <Button type="standart" onClick={() => selectFile('fileElem')}>
                Prisegti priedą
              </Button>
              <input
                type="file"
                id="fileElem"
                accept="application/pdf"
                className="d-none"
                onChange={(e) => setFileToUpload(e.target.files[0])}
              />
              <p style={{ marginTop: '0.5rem' }}>
                {fileToUpload && fileToUpload.name ? fileToUpload.name : ''}
              </p>
              {notValid && !fileToUpload && (
                <p
                  className={styles.error}
                  style={{ textAlign: 'center', width: '100%' }}
                >
                  Privalote pasirinkti priedą
                </p>
              )}
            </div>
            <div className={styles.btnContainer}>
              <Button type="standart" onClick={() => yes(requestId)}>
                Išsaugoti
              </Button>
              <Button type="cancel" onClick={() => cancel()}>
                Atšaukti
              </Button>
            </div>
          </WithSpinner>
        </div>
      </div>
    )
  );
};

// const mapStateToProps = (state) => ({
//   loading: state.dashboardState.isOnSync,
// });

export default connect()(ConfirmRequestModal);
